import type { CombinedError, OperationContext, OperationResult } from "urql"
import { useMutation } from "urql"

import {
  AssignUserRolesDocument,
  type Mutation,
  type RoleMutationBatchAddUserRolesArgs,
  type UserMutationUpdateArgs,
} from "@/graphql/codegen/graphql"

export const useAssignUserRole = (): {
  update: (
    variables: RoleMutationBatchAddUserRolesArgs,
    context?: Partial<OperationContext>
  ) => Promise<OperationResult<Pick<Mutation, "user">, UserMutationUpdateArgs>>
  fetching: boolean
  error?: CombinedError
} => {
  const [{ fetching, error }, update] = useMutation<Pick<Mutation, "user">, UserMutationUpdateArgs>(
    AssignUserRolesDocument
  )

  return { update, fetching, error }
}
